import React, { useState } from "react";
import "./starRating.css";

const StarRating = ({ rating, onRatingSelect }) => {
  const [hoverRating, setHoverRating] = useState(0);
  const descriptions = ["Bad", "Okay", "Good", "Very Good", "Excellent"];

  const handleMouseEnter = (index) => {
    setHoverRating(index + 1);
  };

  const handleMouseLeave = () => {
    setHoverRating(0);
  };

  return (
    <div className="star-rating" onMouseLeave={handleMouseLeave}>
      <div>
        {Array.from({ length: 5 }, (_, index) => (
          <span
            key={index}
            className={`star ${
              index < Math.floor(hoverRating)
                ? "filled"
                : index < Math.floor(rating)
                ? "filled"
                : ""
            }`}
            onClick={() => {
              onRatingSelect(index + 1);
              setHoverRating(0);
            }}
            onMouseEnter={() => handleMouseEnter(index)}
            title={descriptions[index]}
          >
            {index < Math.floor(hoverRating) ? "★" : index < Math.floor(rating) ? "★" : "☆"}
          </span>
        ))}
      </div>
      <div className="rating-description">
        {(hoverRating > 0 || rating > 0) && (
          <span>
            {hoverRating > 0 ? hoverRating : rating} Star{hoverRating > 1 || rating > 1 ? "s" : ""}{" "}
            ({descriptions[Math.floor((hoverRating > 0 ? hoverRating : rating) - 1)]})
          </span>
        )}
      </div>
    </div>
  );
};

export default StarRating;
